// extracted by mini-css-extract-plugin
export default {"list_container":"ResultList_list_container__aYkWY","list_wrapper":"ResultList_list_wrapper__-e6t0","item":"ResultList_item__9RFHS","selected":"ResultList_selected__XmrgK"};